import angular from 'angular';
import IconDirective from './directives/icon/IconDirective';
import codepoints from './directives/icon/generated/codepoints.json';

export default angular.module('edge.platform.widgets.icon', [])
    .constant('GW_ICON_FONT_CODEPOINTS', codepoints)
    .directive('gwIcon', IconDirective);
